// import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import React, { useState, useEffect, useRef } from "react";
import "./ReminderApp.css";
import notificationSound from "./notification.mp3"
import Setting from "./Setting.js"

// ReactGA.initialize(process.env.GA_TRACKING_ID);
ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
console.log(process.env.REACT_APP_GA_MEASUREMENT_ID);
console.log(process.env.REACT_APP_GA_TRACKING_ID);

const ReminderApp = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [workTime, setWorkTime] = useState(25);
    const [breakMsg, setBreakMsg] = useState("Let's take a Walk...");
    const [workMsg, setWorkMsg] = useState("Let's do some work...");
    const [breakTime, setBreakTime] = useState(5);
    const [timer, setTimer] = useState(workTime * 60); // Initial timer value in seconds
    const [isRunning, setIsRunning] = useState(false); // State to track if the timer is running
    const [mode, setMode] = useState("work"); // State to track the current mode ("work" or "break")
    const [theme, setTheme] = useState(true); // State to track the current theme ("dark" or "light")
  
    useEffect(() => {
    // ReactGA.pageview(window.location.pathname + window.location.search);

      let interval;
      if (isRunning && timer > 0) {
        console.log(timer)
        interval = setInterval(() => {
          setTimer((prevTimer) => prevTimer - 1);
        }, 1000);
      } else if (isRunning && timer === 0) {
        // Timer has reached 0, switch to break mode
        setMode((prevMode) => (prevMode === "work" ? "break" : "work"));
        setTimer(mode === "work" ? breakTime * 60 : workTime * 60); // Reset timer based on the mode
  
        // Show notification
        showNotification(mode === "work" ? breakMsg : workMsg);
      }
  
      return () => {
        clearInterval(interval);
      };
    }, [isRunning, timer, mode]);
  
    const handleThemeChange = () => {
        setTheme(!theme);
      };

    const handleOpenModal = () => {
        setIsOpen(true);
      };
    
      const handleCloseModal = () => {
        setIsOpen(false);
      };
    
      const handleSaveSettings = () => {
        // Save workTime and breakTime values to your app's state or storage
        // You can access the values from workTime and breakTime state variables
        if (!isRunning) {
            setTimer(mode === "work" ? workTime * 60 : breakTime * 60);
        }
        console.log("Work Time:", workTime);
        console.log("Break Time:", breakTime);
      };
    
      const handleChangeWorkTime = (e) => {
        setWorkTime(Number(e.target.value));
      };
      const handleChangeWorkMsg = (e) => {
        setWorkMsg(e.target.value);
      };
      const handleChangeBreakMsg = (e) => {
        setBreakMsg(e.target.value);
      };
    
      const handleChangeBreakTime = (e) => {
        setBreakTime(Number(e.target.value));
      };
    const startTimer = () => {
      setIsRunning(true);
      // Play notification sound
        notificationSoundRef.current.play();

    };
  
    const pauseTimer = () => {
      setIsRunning(false);
    };
  
    const resetTimer = () => {
      setIsRunning(false);
      setTimer(mode === "work" ? workTime * 60 : breakTime * 60);
    };
  
    const stopTimer = () => {
      setIsRunning(false);
      setTimer(workTime * 60); // Reset timer to default value
      setMode("work"); // Reset mode to "work"
    };
  
    const toggleTheme = () => {
      setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
    };
    const notificationSoundRef = useRef(new Audio(notificationSound));

    // Function to play the notification sound
    const playNotificationSound = () => {
      // Check if the notification sound ref is available
      if (notificationSoundRef.current) {
        notificationSoundRef.current.play();
      }
    };
    
    const showNotification = (message) => {
      // Check if browser supports notifications
      if ("Notification" in window && Notification.permission === "granted") {
        playNotificationSound();
        new Notification("Reminder", {
          body: message,
          icon: "/timer.png", // Icon for the notification 
        });
        
        // const notificationSound = new Audio("/Users/sikanderkhan/Documents/Github/React/take-a-break/notification.mp3"); // Replace with your own notification sound file
        // notificationSound.play();

        // Play notification sound
      }
    };
  
    const requestNotificationPermission = () => {
      // Request permission for notifications
      if ("Notification" in window) {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            showNotification("Notification support enabled!");
          }
        });
      }
    };
  
    useEffect(() => {
      // Request notification permission on component mount
      requestNotificationPermission();
    }, []);
  
  return (
    <div className={`app-container ${theme ? "dark" : "light"}-theme`}>
      <div className="timer-container">
        
        <div
          className={`timer timer-${mode} ${
            timer <= breakTime * 60  && mode === "work" ? "timer-alert" : ""
          }`}
        >{`${Math.floor(timer / 60)
          .toString()
          .padStart(2, "0")}:${(timer % 60).toString().padStart(2, "0")}`}</div>
        <div className={`mode mode-${mode}`}>{mode === "work" ? "Work" : "Break"}</div>
        <div className="circle-animation" />
      </div>
      <div className="buttons-container">
        {!isRunning ? (
          <button className="start-button" onClick={startTimer}>
            Start
          </button>
        ) : (
          <>
            <button className="pause-button" onClick={pauseTimer}>
              Pause
            </button>
            <button className="stop-button" onClick={stopTimer}>
              Stop
            </button>
          </>
        )}
        <>
        <button className="reset-button" onClick={resetTimer}>
          Reset
        </button>
        </>
      </div>
        <button className="buttons-container setting-button" onClick={handleOpenModal}>
          Settings
        </button>
      <audio ref={notificationSoundRef} src={notificationSound} />
      <Setting
        isOpen={isOpen}
        onClose={handleCloseModal}
        onSave={handleSaveSettings}
        workTime={workTime}
        breakTime={breakTime}
        workMsg={workMsg}
        breakMsg={breakMsg}
        onChangeBreakMsg={handleChangeBreakMsg}
        onChangeWorkMsg={handleChangeWorkMsg}
        onChangeWorkTime={handleChangeWorkTime}
        onChangeBreakTime={handleChangeBreakTime}
        theme={theme}
        handleThemeChange={handleThemeChange}
      />
      <h5 className="rights"> - Developed by <a href="https://sikander27.github.io/" >Sikander Khan</a></h5>
      <h2 className="logo">PEASE.<span style={{fontFamily: "cursive"}}>Reminder</span></h2>
      
    </div>
  );
};

export default ReminderApp;
